import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import * as Util from '@/functions/Util';

export default class ProClienteContratoValidation extends DefaultValidation{

    validate(pro_contrato, refs, root, horaTemp){ 
        let validated = true;

        if (Util.isNull(pro_contrato.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(pro_contrato.idtiposervico)) {
            refs.tiposervicoInput.focusedOut = true;
            validated = false;
        }
        if (Util.isNull(pro_contrato.diaspadrao)) {
            refs.diasInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(horaTemp.HH) || Util.isNull(horaTemp.mm)) {
            refs.horasDiaInput.focusedOut = true;
            validated = false;
        }

        if (!validated){
            root.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
        }

        return validated;
    }

}